import React from "react";
import MainBox from "../Items/MainBox";
export default function StartENGH(props) {
  function radioOnChange(e) {
    props.setGotThePackage(e.target.value);
  }
  function packageChoose(e) {
   
    props.setWhichPackage((prev) => {
      return { ...prev, [e.target.value]: e.target.checked };
    });
  }
  return (
    <MainBox>
      <h1 style={{ textAlign: "center" }}>
        به فرم ثبت گزارش چهاردهمین رویداد مدرسه انقلاب خوش آمدید
      </h1>
      <div
        className="startText"
        style={{ textAlign: "justify", width: "60%", margin: "0 auto" }}
      >
        <p>
          انجمنی عزیز، سلام
          <br />
          <br />
          به بخش ثبت گزارش چهاردهمین رویداد مدرسه انقلاب خوش اومدی.
          <br />
          <br />
          شرکت کردن شما تو این رویداد نشون دهنده تعهدتون به ارزش های اسلام و
          انقلابه. ما صمیمانه از شما بابت همراهیتون در این رویداد تشکر میکنیم.
          امیدواریم که تونسته باشیم با همدیگه یه گام بلند برای پیشبرد اهداف
          انقلاب اسلامی و جهاد تبیین برداشته باشیم.
          <br />
          <br />
          این بخشی که قراره باهم شروع کنیم، برای جمع آوری و ثبت گزارش ها و تجربه
          های شما تو برپایی مدرسه انقلابه. سعی کنید که تو هر مرحله، با هم گروهی
          هاتون به دقت بخش های مختلف رو تکمیل کنید و فعالیت هاتون رو ثبت و منتشر
          کنید تا ما و بقیه بچه های انجمن هم ببینیم تو مدرستون چیکار کردید.
          <br />
          <br />
          {/* راستی، شما میتوانید برای دیدن فیلم های آموزشی در خصوص تکمیل هرکدوم از
        مرحله ها، به کانال رادیو عقیق با آدرس
        <BaleLink link={"@aghigh_ayandehsazan"} /> و کانال مدرسه انقلاب با آدرس{" "}
        <BaleLink link={"@madreseenghelab_1403"} /> تو پیامرسان بله مراجعه کنید.
        ما اونجا براتون کلی فیلم آموزشی فرستادیم که مرحله به مرحله به شما برای
        ورود فعالیت هاتون به بالاترین کیفیت کمک کنه.
        <br />
        <br />
        سردبیرای عقیق هم آمادن که هرجا سوال داشتید ازشون بپرسید. ما هم اینجا
        کنارتونیم و میتونید تو بله بهمون با نشانی
        {" "}<BaleLink link={"@aghigh_supportt"} />{" "}
        پیام بدید و سوالاتتون رو بپرسید.
        <br />
        <br /> */}
          حالا وقتشه که یه یاعلی بگیم و شروع کنیم...
        </p>
        <div
          style={{
            width: "70%",
            height: 1,
            background: "#ccc",
            textAlign: "center",
            margin: "0 auto",
          }}
        ></div>
        {!props.disableVote && (<div>
          <p>
            در ابتدا تعیین کنید که آیا اقلام مدرسه انقلاب به دست شما رسیده است
            یا خیر؟ 
            <span style={{color:'red'}}>*</span>
          </p>
          <div
            style={{
              width: "50%",
              margin: "0 auto",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <div>
              <label htmlFor="gotThePackage">بله</label>
              <input
                type="radio"
                name="gotThePackage"
                value={true}
                onChange={radioOnChange}
              />
            </div>
            <div>
              <label htmlFor="gotThePackage">خیر</label>
              <input
                type="radio"
                name="gotThePackage"
                value={false}
                onChange={radioOnChange}
              />
            </div>
          </div>
          {props.gotThePackage === "true" ? (
            <div
              style={{
                // width: "50%",
                // margin: "0 auto",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <div>
                <input
                  type="checkbox"
                  name="gotThePackage"
                  onChange={packageChoose}
                  value={"comic"}
                />
                <label
                  style={{ fontSize: "1em", fontWeight: "normal" }}
                  htmlFor="packageCheck"
                >
                  مجموعه روایت فتح (پارچه کمیک)
                </label>
              </div>
              <div>
                <input
                  type="checkbox"
                  name="gotThePackage"
                  onChange={packageChoose}
                  value={"poster"}
                />
                <label
                  style={{ fontSize: "1em", fontWeight: "normal" }}
                  htmlFor="packageCheck"
                >
                  پوستر جشنواره
                </label>
              </div>
              <div>
                <input
                  type="checkbox"
                  name="gotThePackage"
                  onChange={packageChoose}
                  value={"qr"}
                />
                <label
                  style={{ fontSize: "1em", fontWeight: "normal" }}
                  htmlFor="packageCheck"
                >
                  کیوآر کد محتوایی
                </label>
              </div>
            </div>
          ) : null}
        </div> )}
      </div>
    </MainBox>
  );
}

function BaleLink(props) {
  return (
    <a
      style={{
        color: "#3851d5",
        direction: "ltr",
        display: "inline-block",
      }}
      target="_blank"
      href={"https://ble.ir/" + props.link}
    >
      {props.link}
    </a>
  );
}
